import memoize from 'memoize-one';
import {MovingAverageChartData} from 'views/storyboard/utils/calculations/chartMovingAverage';
import {LinearRegressionChartData} from 'views/storyboard/utils/calculations/chartLinearRegression';


type ChartDatapointTotalsData = (
    MovingAverageChartData | LinearRegressionChartData
);

export const getChartDatapointTotals = memoize(
    // Calculates the total for every key for every data point and adds it together
    (
        data: ChartDatapointTotalsData[],
        dataKeys: string[],
        excludedKeys: string[] = []
    ): number[] => {
        const usingKeys = dataKeys.filter((key) => !excludedKeys.includes(key));
        return data.map((el) => usingKeys.reduce(
            (keyAccumulator, keyCurrentValue) => keyAccumulator + (
                (el?.[keyCurrentValue as keyof ChartDatapointTotalsData] as number | null) || 0), 0,
        ));
    },
);
